import { Component, OnInit } from '@angular/core';

import { PaginationService } from '../../../../services/pagination/pagination.service';

@Component({
  selector: 'app-page-number',
  templateUrl: './page-number.component.html'
})
export class PageNumberComponent implements OnInit {

  pages: any[];
  selectedIndex = 1;

  constructor(private readonly paginationService: PaginationService) {
  }

  ngOnInit(): void {
    this.paginationService.pages.subscribe((pages: any[]) => {
      this.pages = pages;
    })

    this.paginationService.pageActuelReload.subscribe((page: number) => {
      if (page) {
        this.selectedIndex = page;
      } else {
        this.selectedIndex = 1;
      }
    })
  }

  changerPage(page: number) {
    this.paginationService.changePageActuel(page);
    this.selectedIndex = page;
  }

  changerPagePrecedente() {
    this.changerPage(this.selectedIndex - 1);
  }

  changerPageSuivante() {
    this.changerPage(this.selectedIndex + 1);
  }

}
